import { AgentChatAction } from './agent-action.model';
import { AgentMessageRole, AgentUsageDto } from './agent-api.model';

/** Delivery state of a message shown in the chat. */
export type AgentChatMessageStatus = 'sent' | 'pending' | 'failed';

/** Message as rendered by the chat; built from `AgentMessageDto` or appended locally for the user. */
export interface AgentChatMessage {
  /** Backend id, or a locally generated one for user messages appended before the response arrives. */
  id: string;
  role: AgentMessageRole;
  content: string;
  /** Buttons rendered under the message; empty for user messages and unsupported action types. */
  actions: AgentChatAction[];
  createdAt: string | null;
  usage: AgentUsageDto | null;
  status: AgentChatMessageStatus;
}

/**
 * Errors the chat distinguishes; everything else is `generic`. `accessNotGranted` and `limitReached` switch the
 * assistant state instead of being shown as an error.
 */
export type AgentChatErrorKind = 'generic' | 'accessNotGranted' | 'limitReached' | 'conversationNotFound';

export interface AgentChatError {
  kind: AgentChatErrorKind;
  /** Title of the error banner. */
  message: string;
  /** Second line of the banner; absent when the title says it all. */
  detail?: string;
}
